import { Box, Flex, HStack, IconButton, VStack } from '@chakra-ui/react';
import { FaTimes } from 'react-icons/fa';
import DropDown from 'components/common/Selectable/DropDown';
import ProductFieldInput from 'components/common/ProductFieldInput';

type ExpressionProps = {
  onExpressionChange(a: string, b: string, c: object, d?: boolean): void;
  deleteExpression(a: string, b: string, c: string): void;
  paramKey: string;
  pkey: string;
  item: { if: string; expression: string; operator: string };
  exKey: string;
  showOperator: boolean;
};
const Expression = ({
  onExpressionChange,
  deleteExpression,
  paramKey,
  pkey,
  item,
  exKey,
  showOperator,
}: ExpressionProps) => {
  const renderOperator = (
    pkeyVal: string,
    exKeyVal: string,
    dataVal: {
      [x: string]: string;
      if: string;
      expression: string;
      operator: string;
    },
    showOperatorVal: boolean
  ) => {
    if (!showOperatorVal) return <Box />;

    const val1Name = Object.keys(dataVal)[0];
    const val2Name = Object.keys(dataVal)[1];
    const val3Name = Object.keys(dataVal)[2];
    const ifState = dataVal[val1Name];
    const exp = dataVal[val2Name];
    const op = dataVal[val3Name];

    return (
      <HStack flex={1} justifyContent="center" minW={250}>
        <DropDown
          selectValue="AND"
          value={op}
          bgColor="white"
          overrideStyles={{
            control: {
              bgColor: 'white',
              minW: 100,
            },
          }}
          filterData={['AND', 'OR']}
          setFilteredData={(name, value) => {
            const data = {
              [val1Name]: ifState,
              [val2Name]: exp,
              [val3Name]: value,
            };

            onExpressionChange(pkeyVal, exKeyVal, data);
          }}
        />
      </HStack>
    );
  };

  if (item === undefined) {
    return <Box />;
  }

  const ifState = item.if;
  const exp = item.expression;
  let op = item.operator;

  if (op === undefined) op = 'AND';
  const val1Name = 'if';
  const val2Name = 'expression';
  const val3Name = 'operator';
  let data = {
    [val1Name]: ifState,
    [val2Name]: exp,
    [val3Name]: op,
  };
  return (
    <VStack flex={1} justifyContent="center">
      <HStack
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          m: 2.5,
          p: 2.5,
          bgColor: 'base2Colour.400',
          w: '98%',
        }}
      >
        <Flex>
          <DropDown
            selectValue="If"
            bgColor="white"
            overrideStyles={{
              control: {
                bgColor: 'white',
                minW: 50,
              },
            }}
            value={ifState}
            filterData={['If']} // , 'If Not'
            setFilteredData={(_, value) => {
              data = {
                [val1Name]: value,
                [val2Name]: exp,
                [val3Name]: op,
              };
              onExpressionChange(pkey, exKey, data);
            }}
          />
        </Flex>
        <Flex flex={6} pl={2.5}>
          <ProductFieldInput
            name="expression"
            value={exp}
            onChange={(e) => {
              data = {
                [val1Name]: ifState,
                [val2Name]: e.target.value,
                [val3Name]: op,
              };
              onExpressionChange(pkey, exKey, data);
            }}
          />
        </Flex>
        <IconButton
          aria-label="Delete expression"
          icon={<FaTimes />}
          minH={7}
          px={2.5}
          fontSize="md"
          onClick={() => deleteExpression(paramKey, pkey, exKey)}
          ml={2.5}
        />
      </HStack>
      {renderOperator(pkey, exKey, data, showOperator)}
    </VStack>
  );
};

export default Expression;
